import { StandardAlert } from '@cimplico/components';
import { useState, useEffect } from 'react';
import plural from '../../utilities/plural';

export type ErrorItem = {
    worksheetName: string;
    resourceName: string;
    message: string;
};

type BulkCarryForwardResourcesErrorsProps = { results: { successCount: number; errors: ErrorItem[] }; onCloseBanner: () => void };

function BulkCarryForwardResourcesErrors({ results, onCloseBanner }: BulkCarryForwardResourcesErrorsProps): JSX.Element {
    const [viewMore, setViewMore] = useState(false);
    const [isOpen, setIsOpen] = useState(true);
    const { errors, successCount } = results;

    useEffect(() => {
        setViewMore(false);
        setIsOpen(true);
    }, [results]);

    const errorLines = errors.map((e) => `${e.worksheetName} — ${e.resourceName}: ${e.message}`);

    if (!isOpen) return <></>;

    return (
        <div className="text-left mt-2">
            <StandardAlert
                type="error"
                title={`Failed to carry forward ${errors.length} ${plural(errors.length, 'resource', 'resources')}. ${
                    successCount > 0 ? `${successCount} carried forward succesfully.` : ''
                }`}
                description={viewMore ? errorLines : undefined}
                onClose={() => {
                    setIsOpen(false);
                    onCloseBanner();
                }}
            >
                {!viewMore && <StandardAlert.Button onClick={() => setViewMore(true)}>View error details</StandardAlert.Button>}
                {viewMore && <StandardAlert.Button onClick={() => setViewMore(false)}>View less</StandardAlert.Button>}
            </StandardAlert>
        </div>
    );
}
export default BulkCarryForwardResourcesErrors;
